module.exports = __webpack_public_path__ + "static/phone-1-642039eb598c5d88ff1c0c35edceb886.svg";